const ESTADOS_PAGABLES = new Set([0, 3, 4, 5]);

export function isPlazoPagable(estado) {
    return ESTADOS_PAGABLES.has(estado);
}
